"use strict";
/**
 * Copyright © 2020 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withSearchResult = exports.SearchResultProvider = exports.useSearchResultContext = void 0;

var react_1 = __importStar(require("react"));

var query_string_1 = __importDefault(require("query-string"));

var SearchClient_1 = __importDefault(require("../SearchClient"));

var searchClient = new SearchClient_1.default();
/**
 * Search result context
 */

var defaultSearchResults = {
  results: [],
  setResult: function setResult() {},
  searchTerm: '',
  setSearchTerm: function setSearchTerm() {
    return '';
  }
};
var searchResultContext = react_1.default.createContext(defaultSearchResults);

exports.useSearchResultContext = function () {
  return react_1.useContext(searchResultContext);
};

exports.SearchResultProvider = function (_a) {
  var children = _a.children;

  var _b = react_1.useState([]),
      results = _b[0],
      setResult = _b[1];

  var _c = react_1.useState(''),
      searchTerm = _c[0],
      setSearchTerm = _c[1];

  var searchPagePath = process.env.BODILESS_SEARCH_PAGE || 'search';

  var search = function search(term) {
    var searchResult = searchClient.search(term);
    setResult(searchResult);
  };

  var didMountRef = react_1.useRef(false);
  var searchTermRef = react_1.useRef('');
  react_1.useEffect(function () {
    if (!didMountRef.current) {
      didMountRef.current = true;
      var q_1 = query_string_1.default.parseUrl(window.location.href, {
        parseFragmentIdentifier: true
      }).fragmentIdentifier || '';

      if (typeof q_1 === 'string') {
        searchClient.loadIndex().then(function () {
          return search(q_1);
        });
        setSearchTerm(q_1);
      }
    } else if (searchTermRef.current !== searchTerm) {
      searchClient.loadIndex().then(function () {
        return search(searchTerm);
      });
      window.location.href = "/" + searchPagePath + "/#" + encodeURIComponent(searchTerm);
      searchTermRef.current = searchTerm;
    }
  });
  var contextValue = {
    results: results,
    setResult: setResult,
    searchTerm: searchTerm,
    setSearchTerm: setSearchTerm
  };
  return react_1.default.createElement(searchResultContext.Provider, {
    value: contextValue
  }, children);
};

exports.withSearchResult = function (Component) {
  var WithSearchResult = function WithSearchResult(props) {
    return react_1.default.createElement(exports.SearchResultProvider, null, react_1.default.createElement(Component, __assign({}, props)));
  };

  return WithSearchResult;
};